
import { v4 } from "uuid";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppMonthSelect from "@/components/common/MonthSelect.vue";

export default Vue.extend({
	data(){
		return {
			uid: v4(),
		};
	},
	props: {
		value: {
			type: [String, Array as ()=>string[]],
			required: true
		},
		multi: Boolean,
		label: {
			type: [Object as ()=>TranslateResult, String],
			default():TranslateResult{
				if (this.multi) return this.$ct("bank-kinds");
				return this.$ct("bank-kind");
			}
		}
	},
	methods: {
		setMonth(value:number){
			this.$emit("input", `${value}`);
		},
		getSelectedMonth():number{
			let val = this.value;
			if (typeof(val) == "object") {
				val = this.value[0];
			}
			let number = parseInt(val);
			if (Number.isNaN(number)){
				this.setMonth(1);
			}
			if (number < 1) {
				this.setMonth(1);
			}else if (number > 12) {
				this.setMonth(12);
			}
			return number;
		}
	},
	components: {
		AppMonthSelect
	},
	i18nEx: {
		componentPrefix: "components.models"
	}
});
